import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SocketProvider } from './contexts/SocketContext';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ShinyCardsProvider } from './contexts/ShinyCardsContext';
import App from './App';
import './styles/global.css';
import './styles/cards.css';
import './styles/animations.css';
import './styles/tv-mode.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <ShinyCardsProvider>
          <SocketProvider>
            <App />
          </SocketProvider>
        </ShinyCardsProvider>
      </ThemeProvider>
    </AuthProvider>
  </StrictMode>,
);
